var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container-partners"},[_c('VueSlickCarousel',_vm._b({},'VueSlickCarousel',_vm.settings,false),_vm._l((_vm.partnersList),function(partners,index){return _c('div',{key:index,staticClass:"partners-img"},[_c('a',{style:({ backgroundImage: partners.logo }),attrs:{"href":partners.url,"target":"_blank"}})])}),0)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }